export default {
  translation: {
    membershipPlan: {
      dayPass: {
        "1": "초고속 Wi-Fi 및 편의시설 이용",
        "2": "커피 제공",
      },
      virtualAddress: {
        "1": "주소지 등록",
        "2": "우편 수령 및 보관 (최대 30일)",
      },
      silver: {
        "1": "자유석 무제한 이용 + 미국 사업자 주소 등록",
        "2": "모든 이벤트 우선 참여권",
        "3": "매월 회의실 5시간, 인쇄 100매 제공",
        "4": "멤버 디렉토리·커뮤니티 채널 액세스",
        "5": "Arclow 서비스 첫 해 15% 할인",
        "6": "첫 해 반값, 갱신 후 월 $330",
      },
    },
    apply: {
      pageTitle: "82 Office 멤버십 신청서",
      onlyEnglishDescription: "입력 정보는 영어로 작성해 주세요",
      company: {
        label: "회사명",
        placeholder: "회사명을 입력하세요",
      },
      representative: {
        firstName: {
          label: "대표 이름",
          placeholder: "대표 이름을 입력하세요",
        },
        lastName: {
          label: "대표 성",
          placeholder: "대표 성을 입력하세요",
        },
      },
      phone: {
        label: "전화번호",
      },
      email: {
        label: "이메일",
        placeholder: "이메일을 입력하세요",
        required: "이메일을 입력해주세요",
        invalid: "올바른 이메일 주소를 입력해주세요",
      },
      plan: {
        label: "멤버십 플랜",
        priceUnit: {
          year: "년",
          month: "월",
          day: "일",
        },
        discount: "50% 할인",
      },
      terms: {
        title: "멤버십 이용 약관",
        agree: "서비스 이용 약관 동의",
        required: "(필수)",
      },
      payment: {
        title: "결제",
        amountTitle: "결제 금액",
        total: "총 금액",
        popupWarning:
          "결제 창을 정상적으로 열기 위해서는 브라우저에서 팝업을 허용해야 합니다. (웹 브라우저 또는 Chrome 앱 사용을 권장합니다.)",
        pay: "결제",
        failedToOpenPaymentWindow:
          "결제 창을 열 수 없습니다. 브라우저의 팝업 차단 또는 네트워크 문제로 인해 발생할 수 있습니다. 팝업을 허용하고 다시 시도해 주세요!",
        successResultPageDescription:
          "결제가 정상적으로 처리되었습니다. \n아래 버튼을 눌러 원래 페이지로 돌아가 진행해 주세요",
        failedResultPageDescription:
          "결제가 정상적으로 처리되지 않았습니다. \n이전 페이지로 돌아가 다시 결제를 시도해 주세요..",
        loadingResultPageDescription: "결제를 처리하는 중입니다. 잠시만 기다려주세요...",
        returnToPreviousPage: "이전으로 돌아가기",
        failedToProcessPayment: "결제 처리에 실패했습니다. 다시 시도해 주세요.",
        invalidRequestData: "요청 정보가 올바르지 않습니다. 입력 내용을 확인한 뒤 다시 시도해 주세요.",
        welcomeTo82Office: "🎉 82 Office 멤버가 되신 것을 환영합니다!",
        welcomeDescription:
          "멤버십 가입이 성공적으로 완료되었습니다.\n이제 실리콘밸리 82 Office의 공식 멤버로서 다양한 프리미엄 서비스를 이용하실 수 있습니다\n\n📩 이용 안내, 공간 사용 방법, 멤버십 혜택 및 추가 지원 관련 정보는 가입 시 입력하신 이메일로 순차적으로 발송될 예정입니다.\n\n이제 글로벌 비즈니스의 새로운 시작을 함께하세요.\n82 Office가 여러분의 성장을 지원합니다.",
        returnToMain: "메인으로 돌아가기",
      },
    },
    welcome: "82 Office에 오신 것을 환영합니다",
    mainPage: "메인 페이지",
    heroTitle: "Global Market Starts Here: \n82 Office",
    heroDescription: "실리콘밸리 중심에서 비즈니스의\n다음 단계를 준비하세요.",
    profile: "프로필",
    membership: "멤버십",
    reservations: "예약 내역",
    contact: "문의하기",
    credits: "크레딧",
    monthlyCredits: "월간 크레딧",
    creditsRemaining: "남은 크레딧",
    hours: "{{count}}시간",
    hoursAndMinutes: "{{hours}}시간 {{minutes}}분",
    myReservations: "내 예약",
    myPage: "마이페이지",
    logout: "로그아웃",
    contactIntro: "도움이 필요하거나 요청사항이 있으시면",
    contactEmail: "로 연락주시거나 아래 문의 양식을 작성해주세요.",
    wordLimit: "(200자 이내)",
    email: "이메일",
    emailPlaceholder: "email@address.com",
    emailHelper: "답변을 받으실 이메일 주소를 입력해주세요",
    emailRequired: "이메일을 입력해주세요.",
    emailInvalid: "올바른 이메일 주소를 입력해주세요.",
    title: "제목",
    titleRequired: "제목을 입력해주세요.",
    message: "메시지",
    messagePlaceholder: "질문이나 문의 내용을 입력해주세요",
    messageRequired: "메시지를 입력해주세요.",
    messageMaxLength: "메시지는 200자 이내로 입력해주세요.",
    submit: "제출",
    sending: "전송 중...",
    sendSuccess: "문의가 성공적으로 전송되었습니다.",
    sendError: "전송에 실패했습니다. 다시 시도해주세요.",
    notFoundTitle: "페이지를 찾을 수 없습니다",
    notFoundDescription: "페이지 주소를 잘못 입력하셨거나,\n주소 변경 혹은 삭제됐을 수 있습니다.",
    goBackHome: "홈으로 돌아가기",
    loading: "로딩 중...",
    error: "오류가 발생했습니다.",
    retry: "다시 시도",
    cancel: "취소",
    confirmed: "확정",
    cancelled: "취소됨",
    pending: "대기",
    free: "무료",
    paid: "유료",
    reservationHours: "{{count}}시간",
    noReservations: "해당 월에 예약 내역이 없습니다.",
    timezoneLosAngeles: "(PST/PDT)",
    deleteReservationTitle: "예약을 취소하시겠습니까?",
    deleteReservationDescription: "예약 당일에 취소하는 경우, 사용된 무료 크레딧 또는 결제 금액은 환불되지 않습니다.",
    keepReservation: "유지",
    cancelReservation: "예약 취소",
    reservationDeletedSuccess: "예약이 취소되었습니다",
    reservationDeleteFailed: "예약 취소에 실패했습니다",
    pastReservation: "지난 예약은 취소할 수 없습니다.",
    deletePaymentMethodTitle: "삭제하시겠습니까?",
    deletePaymentMethodDescription: "이 작업을 진행하면 현재 정보가 삭제됩니다.",
    keepPaymentMethod: "유지하기",
    deletePaymentMethod: "삭제하기",
    unsubscribeMembershipTitle: "멤버십을 해지하시겠습니까?",
    unsubscribeMembershipDescription:
      "해지 즉시 멤버십 권한 및 모든 혜택이 제한됩니다.\n이후 예약 및 공간 이용이 불가합니다.",
    unsubscribe: "해지하기",
    goBack: "돌아가기",
    unsubscribeComplete: "멤버십 해지가 완료되었습니다.",
    unsubscriptionSuccess: "멤버십 해지가 완료되었습니다",
    unsubscriptionFailed: "멤버십 해지에 실패했습니다",
    reservationPolicyTitle: "예약 정책 안내",
    commonReservationRules: "공통 예약 규정",
    reservationMaxHoursPerDay: "하루 최대 3시간까지 예약 가능",
    silverMembership: "Silver 멤버십",
    silverNoSameDayReservation: "당일 예약 불가",
    silverFreeHours: "매월 무료 5시간 제공",
    reservationUnavailableTitle: "예약 불가",
    silverMembershipSameDayReservationNotAllowed: "Silver 멤버십은 당일 예약이 불가합니다.",
    onlySilverMembershipReservation: "Virtual Address/Day Pass 멤버십은 예약할 수 없습니다.",
    additionalUsageFee: "추가 이용 요금",
    additionalFeeDescription: "무료 제공 시간을 초과하여 예약할 경우, 30분당 $15의 추가 요금이 부과됩니다.",
    meetingRoomReservations: "미팅룸 예약",
    reserveRoom: "예약하기",
    myReservation: "내 예약",
    reserved: "다른 이용자 예약",
    meetingRoomAlreadyReservedTitle: "예약 불가 안내",
    meetingRoomAlreadyReservedDescription: "선택하신 시간은 더 이상 예약할 수 없습니다. 다른 시간대를 선택해 주세요.",
    reservationLimitReachedTitle: "예약 한도 도달",
    reservationLimitReachedDescription: "하루 3시간 예약 한도에 이미 도달하셨습니다.",
    ok: "확인",
    freeCredits: "무료 크레딧",
    reservingHours: "예약 시간",
    payment: "결제",
    paymentLine: "0.5시간 ($15) x {{count}}",
    total: "합계",
    reservationDialogTitle: "예약",
    startTime: "시작 시간",
    endTime: "종료 시간",
    selectTime: "시간 선택",
    selectStartTimeFirst: "시작 시간을 먼저 선택하세요",
    reserve: "예약하기",
    reservationCreatedSuccess: "예약이 완료되었습니다",
    reservationCreateFailed: "예약 생성에 실패했습니다",
    invalidTimeRange: "시작 시간은 종료 시간보다 늦을 수 없습니다.",
    requiredFieldMissing: "필수 항목이 누락되었습니다.",
    invalidDateFormat: "잘못된 날짜 형식입니다. (YYYY-MM-DD)",
    invalidTimeFormat: "잘못된 시간 형식입니다. (HH:mm)",
    paymentHistory: "결제 내역",
    paymentItem_MEMBERSHIP: "멤버십",
    paymentItem_MEETING_ROOM: "회의실",
    invoice: "청구서",
    refunded: "(환불 완료)",
    pageOf: "{{current}} / {{total}}",
    prev: "이전",
    next: "다음",
    membershipPlan_SILVER: "Silver",
    membershipPlan_VIRTUAL_ADDRESS: "Virtual Address",
    membershipPlan_DAY_PASS: "Day Pass",
    billingCycle_MONTHLY: "월간",
    billingCycle_YEARLY: "연간",
    billingCycle_DAILY: "일일",
    rateOf: "{{billingCycle}} ${{amount}}",
    plan: "플랜",
    notSubscribedToPlan: "플랜에 가입되어 있지 않습니다",
    applyNow: "가입하기",
    nextPaymentDate: "다음 결제일:",
    paymentMethod: "결제 수단:",
    cardLast4: "카드 ({{last4}})",
    settings: "설정",
    paymentType: "결제 수단",
    useAsMain: "기본 카드로 설정",
    deleteCard: "카드 삭제",
    addCard: "카드 추가",
    paymentMethodUpdatedSuccess: "자동 결제 수단이 변경되었습니다.",
    paymentMethodUpdateFailed: "자동 결제 수단 변경에 실패했습니다.",
    paymentMethodAddedSuccess: "결제 수단이 추가되었습니다.",
    paymentMethodDeletedSuccess: "결제 수단이 삭제되었습니다.",
    paymentMethodDeleteFailed: "결제 수단 삭제에 실패했습니다.",
    upgradePlan: "플랜 업그레이드",
    upgradePlanFailed: "플랜 업그레이드에 실패했습니다",
    originalPlan: "기존 플랜",
    eligiblePlan: "업그레이드 가능 플랜",
    additionalPaymentSummary: "추가 결제 요약:",
    remainingDaysLabel: "기존 플랜 잔여 일수: ({{start}} ~ {{end}}): {{days}}일 (①)",
    originalPlanPaidAmount: "잔여일 기준 기존 플랜 기 납부금액: {{full}}×(①/{{cycleDays}}) = {{remaining}} (②)",
    newPlanProratedAmount: "잔여일 기준 새 플랜 요금: {{amount}}×(①/{{cycleDays}}) = {{prorated}} (③)",
    chargedAmount: "청구 금액: ③ - ② = {{charged}}",
    payAmount: "${{amount}} 결제하기",
    selectPlan: "플랜 선택",
    main: "기본",
    representative: "대표자",
    company: "회사",
    phone: "연락처",
    membershipType: "멤버십 타입",
    suiteNumber: "호실 번호",
    membershipPeriod: "멤버십 기간",
    upgradePlanPaymentSuccess: "플랜 업그레이드 결제가 성공적으로 완료되었습니다.",
    loggedOutSuccessfully: "로그아웃 되었습니다",
    signIn: "로그인",
    membershipApplyNow: "멤버십 가입하기",
    reserveRooms: "회의실 예약하기",
    silverTourTitle: "82 Office에 오신 것을 환영합니다!",
    silverTourDescription: "저희가 직접 공간을 안내해 드릴게요.\n15분 투어를 신청하셔서 함께 둘러봐요!",
    silverTourCta: "15분 투어 신청하기",
    silverTourHideForToday: "오늘 하루 동안 보지 않기",
    room: "회의실",
    // 관리자 화면
    adminMembers: "멤버",
    adminReservations: "예약 현황",
    adminMembersTitle: "Members",
    adminReservationsTitle: "Reservations",
    adminSearchPlaceholder: "회사명 검색",
    adminFilterType: "Type",
    adminFilterStatus: "Status",
    adminColumnCompany: "Company",
    adminColumnType: "Type",
    adminColumnStatus: "Status",
    adminColumnPeriod: "Period",
    // count는 i18next의 복수형 예약어라 접미사 키를 찾게 되므로 total을 쓴다.
    adminShowingRange: "총 {{total}}개 중 {{from}}-{{to}}",
    adminEmptyMembers: "조회된 멤버가 없습니다",
    adminLoading: "불러오는 중...",
    adminLoadFailed: "정보를 불러오지 못했습니다. 잠시 후 다시 시도해 주세요.",
    adminMemberDetails: "Member details",
    adminContactInformation: "Contact information",
    adminPreviousPlanHistory: "Previous plan history",
    adminRepresentative: "Representative",
    adminEmail: "Email",
    adminPhoneNumber: "Phone number",
    adminClose: "닫기",
    adminNoRooms: "조회할 회의실이 없습니다",
    adminSelectRoom: "회의실 선택",
    memberType_SILVER_MONTHLY: "Silver (Monthly)",
    memberType_SILVER_YEARLY: "Silver (Yearly)",
    memberType_VIRTUAL_ADDRESS_MONTHLY: "Virtual Address (Monthly)",
    memberType_VIRTUAL_ADDRESS_YEARLY: "Virtual Address (Yearly)",
    memberType_DAY_PASS: "Day Pass",
    memberStatus_ACTIVE: "Active",
    memberStatus_EXPIRED: "Expired",
  },
};
